import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/invitations/$token/accept')({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/invitations/accept',
            search: {
                token: params.token
            }
        });
    }
});
